<script setup lang="ts">
import useClipboard from 'vue-clipboard3'
import { ref, nextTick, watch } from 'vue'
import { Data } from '@/stores/data'
import { toPng, toJpeg } from 'html-to-image'
// import { MdEditor } from 'md-editor-v3';
// import 'md-editor-v3/lib/style.css';
import { MdPreview, MdCatalog } from 'md-editor-v3'
// preview.css相比style.css少了编辑器那部分样式
import 'md-editor-v3/lib/preview.css'
import { Utill } from '@/stores/Utill'
import { ElementTip } from '@/stores/ElementTip'
import { HTTP } from '@/network/http'
import { useRoute } from 'vue-router'
import { jiaoanFilterKey, modeTitle } from '@/stores/StaticText'
import CommentsMessageItem from '@/components/Application/XhComponents/item/CommentsMessageItem.vue'
import emitter from '@/stores/mitt'
import html2canvas from 'html2canvas'
// import sanitizeHtml from 'sanitize-html';
// import renderMathInElement from 'katex/contrib/auto-render/auto-render'
const scrollElement = document.documentElement
const route = useRoute()
const resourceType = (route.params.resourceType ? route.params.resourceType : '') as string
const $emit = defineEmits(['showFeedback', 'anginAnswer', 'addActionCard', 'clickExampleCard'])

const captureDiv = ref(null)
let timeIndex: any = null

// const sanitize = (html) => sanitizeHtml(html);

interface BackListType {
  text: string
  isSelected: boolean
  id: string
}
//错误反馈
const backList = ref<BackListType[]>([
  { text: '回答有误不准确', isSelected: false, id: '1' },
  { text: '产品功能不完善', isSelected: false, id: '2' },
  { text: '回答存在不当言论', isSelected: false, id: '3' }
])

//导出文档按钮文字
enum loadStateText {
  '下载',
  ''
}
let loadState = ref(0) //下载文档状态和loadStateText一一对应
let isButtonDisabled = ref(false)
let textareaData = ref() //输入的内容
let isShowFeedBack = ref(false) //是否显示反馈面板
let isCanDownLoade = ref(false)
// let csStr = ['111111111111111', '2222222222222222', '33333333333333333'];
let strIndex = ref(1)
//父级入参
let def = defineProps({
  backText: {
    type: [String, Array],
    default: ''
  },
  isCopy: {
    //可以copy证明是否已经显示完成
    type: [Boolean, Array],
    default: false
  },
  isFeedback: {
    type: Boolean,
    default: false
  },
  isHtml: {
    type: Boolean,
    default: false
  },
  problem: {
    type: [String, Object],
    default: ''
  },
  messageKey: {
    type: String,
    default: ''
  },
  isLast: {
    type: Boolean,
    default: false
  },
  isShowJiaoanBtn: {
    type: Boolean,
    default: false
  },
  loadingType: {
    type: Array,
    default: null
  },
  otherData: {
    type: Object,
    defaule: {}
  }
})
let clickBad = ref(false) //点踩
let clickGood = ref(false) //点赞
const textCtr = ref<HTMLElement | null>(null);

console.log(typeof def.backText)

// 点击复制
function touchCopy() {
  // 调用
  copy(getCurrText())
  // console.log(getCurrText())

}
function insertDocument() {
  emitter.emit('insert-Document', getCurrText())
}
function getCurrText() {
  if (typeof def.backText === 'string') {
    return def.backText
  } else {
    return (def.backText as Array<string>)[strIndex.value - 1]
  }
}

//点击下载按钮
async function xzBtnHandler(eve: MouseEvent) {
  if (isButtonDisabled.value) {
    // ElementTip.errorTip('文档已生产，点击' + loadStateText['2'] + '按钮导出文档吧。')
    return;
  }
  isButtonDisabled.value = true;
  loadState.value = 1;
  const mermaidElements = textCtr.value.querySelectorAll('.md-editor-mermaid');
  let imageUrls = [];
  for (const element of mermaidElements) {
    try {
      const canvas = await html2canvas(element as HTMLElement);
      const dataUrl = canvas.toDataURL('image/png'); // 将画布转换为 base64 PNG URL
      imageUrls.push(dataUrl);
    } catch (error) {
      console.error('转换失败', error);
    }
  }
  let mermaidRegex = /```mermaid[\s\S]*?```/g;

  let str = getCurrText();
  let index = 0;
  str = str.replace(mermaidRegex, (match) => {
    // 如果 arr 中有对应的 src 地址则替换，否则保留原样
    return imageUrls[index] ? `<img src="${imageUrls[index++]}">` : match;
  });
  HTTP.getWordUrl(str)
    .then(
      (data) => {
        loadState.value = 0;
        if (data.code == 200 && data.data) {
          downWord(data)
        } else {
          wordloaderr()
        }

      },
      (err) => {
        //小鸿发出错误提示
        wordloaderr()
      }
    )
    .catch((e) => {
      //小鸿发出错误提示
      wordloaderr()
    })


  timeIndex = setTimeout(() => {
    recoveryStatus();
  }, 3000);
}
function downWord(data: any) {
  console.log(">>>>datadatadatadata>>>", data)

  const link = document.createElement('a');
  link.href = data.data;
  // link.download = data.name;
  // link.target = '_blank';
  link.click();
}
function wordloaderr() {
  ElementTip.errorTip('导出失败，请稍后重试');
  recoveryStatus();
  loadState.value = 0;
}

// 使用插件
const { toClipboard } = useClipboard()
const copy = async (msg: string) => {
  try {
    // 复制
    await toClipboard(msg)
    ElementTip.successTip('复制成功')
    // 复制成功
  } catch (e) {
    // 复制失败
    ElementTip.errorTip('复制失败')
  }
}
//点击反馈选项
function clickbackListItem(str: BackListType) {
  console.log(str.text)
  str.isSelected = !str.isSelected
}
//点击反馈提交
function clickbTj() {
  const filteredList = backList.value.filter((item) => item.isSelected)
  // 将 id 属性拼接成字符串
  let tpm = filteredList.map((item) => item.id).join('|')
  isShowFeedBack.value = false
  ElementTip.successTip('您幸苦啦，反馈已收到')
  let feetData = {
    tpm,
    stat: 2,
    wordText: getCurrText(),
    guestbook: textareaData.value,
    query: def.problem
  }
  uploadFeedBack(feetData)
}
//上传反馈
function uploadFeedBack(feetData: object) {
  // HTTP.uploadFeedBack(feetData)
  //   .then(
  //     (data) => {
  //       console.log(">>tijia成功>>>")
  //     },
  //     (err) => {
  //       console.log(">>tijia失败>>>")
  //     }
  //   )
  //   .catch((e) => {
  //     console.log(">>tijia失败>>>")
  //   })
}

function recoveryStatus() {
  if (timeIndex) {
    clearTimeout(timeIndex)
  }
  isButtonDisabled.value = false
}

function anginAnswer() {
  $emit('anginAnswer', { id: def.messageKey, problem: def.problem })
}

watch(
  () => def.backText.length,
  (newValue, oldValue) => {
    // console.log(def.backText, `imgSrc changed from ${oldValue} to ${newValue}`);
    strIndex.value = def.backText.length
  },
  //深度监听
  { deep: true }
)

function changeStrIndex(num: number) {
  let newNum = strIndex.value + num
  if (newNum < 1) {
    newNum = 1
  } else if (newNum > def.backText.length) {
    newNum = def.backText.length
  }
  // console.log(def.backText.length,">>>>>>", newNum)
  strIndex.value = newNum
}
//点击相似案例
function similarItemClick(itemData: any) {
  $emit('clickExampleCard', itemData)
}
function problemLanjie() {
  if (def.problem && typeof def.problem == 'string' && def.problem.length > 0) {
    return jiaoanFilterKey.some((keyword) => def.problem.includes(keyword))
  }
  return false
}
function isShowCopy() {
  if (typeof def.isCopy === 'boolean') {
    return def.isCopy
  } else {
    return def.isCopy[strIndex.value - 1]
  }
}
function isShowSimilar() {
  if (def.isLast && isShowCopy()) {
    return def.otherData && def.otherData!.similarData && def.otherData!.similarData.length > 0
  }
  return false
}
//是否显示重新回答
function isShowReanswer() {
  if (def.isLast) {
    // if (def.problem && typeof def.problem == 'object' && def.problem.wjId) {
    //      return false
    // }
    return true
  }
  return false
}
</script>

<template>
  <div class="mess">
    <div class="mess-ctr">
      <div class="avatar">
        <img class="rounded-circle" src="@/assets/xh-icon-new.png" alt="avatar" />
      </div>
      <!--      <div class="cro">-->
      <!--        <div class="cro_left_top"></div>-->
      <!--      </div>-->
      <div class="cro-new">
        <img class="cro-img" src="@/assets/cro.svg" alt="" />
      </div>
      <div class="text-ctr" ref="textCtr">
        <div v-if="otherData && otherData.currMode && otherData.currMode != 'noMode'" class="text-title">
          <img :src='"icons/" + otherData.currMode + ".svg"'>
          <span>{{ modeTitle[otherData.currMode] }}</span>
        </div>

        <div v-if="typeof backText === 'string'">
          <p v-if="isHtml" v-html="backText" class="xh-backText-html"></p>

          <div v-else>
            <MdPreview class="backText" :no-katex="false" :codeFoldable="false" v-model="(backText as string)">
            </MdPreview>
          </div>

        </div>

        <!-- <p   v-else-if="typeof backText === 'string'" class="backText">{{ backText }} </p> -->
        <div v-else>
          <!--  :previewTheme="'vuepress'"         -->
          <p v-if="isHtml" v-html="backText[strIndex - 1] as string" class="xh-backText-html"></p>
          <div v-else>
            <!-- <p v-html="backText[strIndex - 1] as string" class="xh-backText-html"></p> -->
            <MdPreview :no-katex="false" class="backText" :codeFoldable="false"
              v-model="(backText[strIndex - 1] as string)"></MdPreview>
            <MdCatalog :scrollElement="scrollElement" />
          </div>

          <!-- <p    class="backText" >{{ backText[strIndex - 1] }}</p> -->
          <div class="switch-ctr" v-if="backText.length > 1">
            <div class="switch-btn" :class="strIndex == 1 ? 'disabled' : ''" @click="changeStrIndex(-1)">
              <img class="jiantou-ico left-jiantou" src="@/assets/jiantou1.svg" alt="avatar" />
              <!-- ‹ -->
            </div>
            <div>{{ strIndex }}/{{ backText.length }}</div>
            <div class="switch-btn" @click="changeStrIndex(1)" :class="strIndex == backText.length ? 'disabled' : ''">
              <img class="jiantou-ico" src="@/assets/jiantou1.svg" alt="avatar" />
              <!-- › -->
            </div>
          </div>
        </div>

        <div class="copyctr" id="copyctr-id" v-if="isShowCopy()">
          <div class="copyBtn" @click="anginAnswer" v-if="isShowReanswer()">
            <!--            <img  src="@/assets/chongshi.svg" >-->
            重新回答
          </div>

          <div class="xh-brns-ctr" v-if='!resourceType'>
            <div class="copyBtn" @click="touchCopy">
              <img src="@/assets/copy.svg">
              复制
            </div>
            <div class="copyBtn xzBtn "
              :class="[loadState == 1 ? 'loadingCLass' : '', isButtonDisabled ? 'isButtonDisabledClass' : '']"
              @click="xzBtnHandler" v-if="getCurrText().length > 200">
              <img v-show="loadState == 1" src="@/assets/hexagon1.svg">
              <img v-show="loadState == 0" src="@/assets/hexagon0.svg">
              <span v-show="loadState == 0">下载 </span>
            </div>
          </div>
          <div class="copyBtn insertBtn" @click="insertDocument" v-else>插入文档</div>
        </div>
      </div>
    </div>
    <!-- //v-show='loadingType && loadingType.length>0 &&strIndex== loadingType.length' -->
    <div class="answer-loading-ctr" :class="strIndex == loadingType.length ? 'show-opacity' : 'hide-opacity'"
      v-if="loadingType && loadingType.length > 0">
      <div class="xh-answer-over" v-if="loadingType[loadingType.length - 1] == 2">
        <img src="@/assets/answerOver.svg" />
        <div>回答完成</div>
      </div>
      <div class="xh-answer-loading" v-else-if="loadingType[loadingType.length - 1] == 1">
        <div>正在回答中</div>
        <div class="xh-loading-move-dian">
          <span class="dot1 loading-dian"></span>
          <span class="dot2 loading-dian"></span>
          <span class="dot3 loading-dian"></span>
        </div>
      </div>
    </div>
    <div class="xh-up-move" v-if="isShowSimilar()">
      <div class="similar-ctr" v-if="isShowSimilar()">
        <p>{{ otherData?.title ? otherData?.title : '为您精选更多内容' }}：</p>
        <div v-for="(item, index) in otherData!.similarData" :key="index" class="list-item"
          @click="similarItemClick(item)">
          <div class="list-text">{{ item.text }}</div>
          <div class="jiantou-ctr">
            <img class="jiantou-ico" src="@/assets/jiantou1.svg" alt="avatar" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.xh-backText-html> :first-child {
  margin-top: 0 !important;
}

.xh-backText-html {
  letter-spacing: 0.4px;
  line-height: 26px;
  padding: 12px 12px 0;

  th {
    padding: 0;
    text-align: left;
    background-color: #f5f2f0;
    font-weight: 700;
    text-align: center;
    border: 1px solid var(--w-e-textarea-border-color);
    line-height: 1.5;
    min-width: 30px;
    padding: 3px 5px;
  }

  td {
    padding: 0;
    text-align: left;
    text-align: center;
    border: 1px solid #ccc;
    line-height: 1.5;
    min-width: 30px;
    padding: 3px 5px;
  }

  ol,
  ul {
    list-style: revert;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 32px;
  }

  dl,
  ol,
  p,
  pre,
  ul {
    margin-top: 0;
    margin-bottom: 10px;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    color: #3e3e45;
    margin-top: 20px;
    margin-bottom: 10px;
    font-weight: 600;
    line-height: 1.25;
  }

  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    font-size: 1em;
  }

  h1 {
    font-weight: 800;
    font-size: 1.4em;
  }

  h2 {
    font-weight: 800;
    font-size: 1.2em;
  }
}
</style>
<style scoped lang="scss">
.text-title {
  border-radius: 8px;
  opacity: 1;
  background: rgba(139, 141, 250, 0.15);
  line-height: 28px;
  padding: 0 12px;
  color: #040A39;
  font-weight: 500;
  white-space: nowrap;
  display: inline-flex;
  gap: 4px;
  margin: 12px 20px 0 20px;
}

.similar-ctr {
  border-radius: 16px;
  opacity: 1;

  background: #ffffff;
  padding: 12px;
  margin-top: 8px;
}

.jiantou-ctr {
  width: 20px;
  height: 20px;
  background: #e5e6eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.list-text {
  width: 76%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-item {
  display: flex;
  border-radius: 8px;
  background: #f7f8fa;
  align-items: center;
  justify-content: space-around;
  margin-top: 4px;
  cursor: pointer;
  line-height: 42px;
}

.answer-loading-ctr {
  font-size: 12px;
  position: absolute;
}

.show-opacity {
  opacity: 1;
}

.hide-opacity {
  opacity: 0;
}

/* .go-on-ico{

} */
.xh-up-move {
  -webkit-animation: slide-up 0.6s ease 0.7s forwards;
  animation: slide-up 0.6s ease 0.7s forwards;
  opacity: 0;
  width: calc(100% - 72px);
  margin-left: 41px;
}

@-webkit-keyframes slide-up {
  0% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-up {
  0% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: 1;
  }
}

.xh-answer-over {
  margin-left: 41px;
  margin-top: 4px;
  display: flex;
  -webkit-animation: fadeInAndOut 0.4s ease 0.4s forwards;
  animation: fadeInAndOut 0.4s ease 0.4s forwards;
}

@keyframes fadeInAndOut {
  0% {
    opacity: 1;
    /* 开始时透明度为 0 */
  }

  100% {
    opacity: 0;
    /* 结束时透明度为 0，消失状态 */
    display: none;
    /* 可选：在动画结束后隐藏 div */
  }
}

@-webkit-keyframes fadeInAndOut {
  0% {
    opacity: 1;
    /* 开始时透明度为 0 */
  }

  100% {
    opacity: 0;
    /* 结束时透明度为 0，消失状态 */
    display: none;
    /* 可选：在动画结束后隐藏 div */
  }
}

.xh-answer-loading {
  margin-left: 41px;
  margin-top: 4px;
  display: flex;
  align-items: baseline;
}

.downTipBtn {
  line-height: 24px;
  border-radius: 8px;
  opacity: 1;
  background: #e5e6eb;
  text-align: center;
  font-size: 12px;
  color: #4e5969;
  margin-top: 8px;
  display: flex;
  /* align-items: center; */
  flex-wrap: nowrap;
  justify-content: center;
}

@keyframes opacityAnimation {

  0%,
  100% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

.cs-move {
  animation: opacityAnimation 0.6s cubic-bezier(1, -0.09, 0, 1.12) infinite;
}

.left-jiantou {
  transform: rotate(180deg);
}

.jiantou-ico {
  /* transform: rotate(180deg); */
  width: 4px;
  /* margin-left: 0.12rem; */
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.switch-ctr {
  display: flex;
  font-size: 12px;
  gap: 4px;
  line-height: 14px;
  align-items: flex-start;
  margin: 10px 20px;
}

.switch-btn {
  /* font-size: 0.18rem;
      text-align: left;
      cursor: pointer; */
  cursor: pointer;
  width: 14px;
  height: 14px;
  display: flex;
  justify-content: center;
}

:deep(.el-textarea .el-input__count) {
  bottom: -18px;
  right: 0px;
}

.backBtn {
  color: #59adec;
  text-align: center;
  width: 100%;
  line-height: 36px;
  font-size: 14px;
  cursor: pointer;
}

.inputCon {
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  margin-top: 9px;
}

.text-ctr.feedbackList {
  /* max-width: 5rem; */
  /* min-width: 260Px; */
  /* width: calc(100% - var(--rate-width) - 16Px); */
  width: 300px;
  margin-left: 41px;
  margin-top: 10px;
  padding: 0;
}

.backListItem {
  margin-top: 9px;
  padding: 4px 12px;
  border: 1px solid #f2f2f2;
  border-radius: 10px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.backListItem.backListItemSelend {
  color: #59adec;
  border: 1px solid #59adec;
}

.seceletList {
  width: 100%;
  box-sizing: border-box;
  /* height: 100%; */
  padding: 8px 16px 3px 16px;
  /* border-top: 1px solid #F2F2F2; */
  border-bottom: 1px solid #f2f2f2;
}

.feedbackList .title {
  font-size: 14px;
  font-weight: 600;
}

.feedback .btn.goodSelecten {
  background: #59adec;
}

.feedback {
  display: flex;
  flex-direction: column-reverse;
  margin-left: 4px;
}

.feedback .btn {
  background-color: #fff;
  padding: 6px;
  border-radius: 50%;
  margin-top: 4px;
  cursor: pointer;
  overflow: hidden;
  min-height: 0;
}

.feedback .btn:last-child {
  margin-top: 0;
}

.feedback .btn img {
  display: block;
  height: 14px;
  width: 14px;
  min-width: 14px;
}

.mess {
  padding: 0 0 16px 0;
  max-width: 95%;
  -webkit-animation: msgLeft 0.5s ease-in-out;
  animation: msgLeft 0.5s ease-in-out;
}

.copyctr {
  display: flex;
  justify-content: end;
  /* padding-bottom: 0.06rem; */
  border-top: 1px solid #f2f2f2;
  padding: 13px 16px 15px;
  margin-top: 2px;
  gap: 6px;
}

.xh-brns-ctr {
  display: flex;
  gap: 6px;
}

.copyBtn {
  cursor: pointer;
  background: #fff;
  color: #4e5969;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 100px;
  line-height: 20px;
  border: 1px solid #e5e6eb;
  // width: 116px;
  font-size: 14px;
  font-weight: 350;
  padding: 3px 14px;
  box-sizing: border-box;
}

.copyBtn:hover {
  background: #E2E5FC;
  border: none !important;
}

.copyBtn img {
  width: 12px;
  margin-right: 2px;
}

.insertBtn {
  background: #485CEC;
  color: #ffffff;
  margin-left: 15px;
}

.insertBtn:hover {
  background: #3347D6;
}

.loadingCLass {
  opacity: 0.7;
  pointer-events: none;
  transform: perspective(1000);
}

.isButtonDisabledClass {
  opacity: 0.7;
  pointer-events: none;
}

.loadingCLass img {
  -webkit-animation: preloader-spin 1s steps(12, end) infinite;
  animation: preloader-spin 1s steps(12, end) infinite;
  /* transform: translateZ(0); */
}

@keyframes preloader-spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes preloader-spin {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}

.mess-ctr {
  display: flex;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.rounded-circle {
  display: block;
}

.avatar {
  min-width: 35px;
  min-height: 35px;
  border-radius: 30px;
  overflow: hidden;

  height: 35px;
  width: 35px;
  flex-shrink: 0;
}

.text-ctr {
  /* white-space: pre-wrap; */
  background-color: #fff;
  /* padding: 10px 12px; */
  /* max-width: calc(100% - 0.35rem); */
  border-radius: 0 20px 20px 20px;
  font-weight: normal;
  /* line-height: 0.24rem; */
  box-sizing: border-box;
  /* margin-left: 0.06rem; */
  min-width: 0;
  overflow: hidden;
  // width: 279px;
  font-size: 14px;
}

.cro {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  transform: rotate(270deg);
}

.cro_left_top {
  background: linear-gradient(180deg, #f3f3f6 0%, #eaedf6 100%);
  border-radius: 0 0 90% 0;
  /* border-bottom: 1px solid #f5f6fa; */
  /* border-right: 2px solid #f5f6fa; */
  width: 100%;
  height: 100%;
}

.cro-new {
  display: flex;
  justify-content: start;
  width: 8px;
  height: 8px;
  flex-shrink: 0;
}

.cro-img {
  width: 8px;
  height: 8px;
}
</style>
